// import img from "../constants/img";
export function onError(e: any) {
    e.target.src = "https://dev.myspa.vn/assets/img/no-img.jpg";
    // e.target.src = img.logoMyspa;
    // e.target.style.objectFit = "contain";
    // e.target.style.transform = "scale(0.6)";
}
